import {writable} from 'svelte/store';
import _ from 'lodash';
import {v4 as uuid4} from 'uuid';

export const confirms = writable([]);

const closeConfirm = id => confirms.update(val => _.filter(val, confirm => confirm.id !== id));

export const showConfirm = (message, {
  id = null,
  alert = false,
  okColor = 'black',
  cancelColor = '#888',
  okText = 'Ok',
  cancelText = 'Cancel'
} = {}) => new Promise(resolve => {
  id = id || uuid4();
  confirms.update(val => [...val, {
    id,
    props: {
      message,
      onCancel: alert ? null : () => {
        resolve(false);
        closeConfirm(id);
      },
      onConfirm: () => {
        resolve(true);
        closeConfirm(id);
      },
      okColor,
      cancelColor,
      okText,
      cancelText
    }
  }]);
});

export const showAlert = (message, id = null) => showConfirm(message, {id, alert: true});
